import { ApiHeader, ApiQuery, ApiTags } from '@nestjs/swagger';
import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Param, Post, Query, Req } from '@nestjs/common';
import { ActivityService } from './activity.service';
import { ActivityDTO, ActivityStatusDTO } from './dto/activity.dto';
import { ActivityResponseModel } from './dto/activity-response.module';
import { AllActivityResponseModel } from './dto/all-activity-response.module';

@ApiTags('Activity')
@Controller('activity')
export class ActivityController {
    constructor (
        private activityService: ActivityService
    ) {}
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/createActivity')
    @ApiQuery({name:'apiVersion'})
    async createActivity(@Query() queryParams, @Body() activityDto:ActivityDTO, @Req() request: Request): Promise<ActivityResponseModel> {
        try {
            return await this.activityService.createActivity(queryParams, activityDto, request);
        } catch (error) {
            return errorHandler(ActivityResponseModel, error);
        }
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getActiveActivities')
    @ApiQuery({name:'apiVersion'})
    async getActiveActivities(@Query() queryParams, @Req() request:Request): Promise<AllActivityResponseModel> {
        try {
            return await this.activityService.getActiveActivities(queryParams, request);
        } catch (error) {
            return errorHandler(AllActivityResponseModel, error);
        }
    }
    
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/updateActivity')
    @ApiQuery({name:'apiVersion'})
    async updateActivity(@Query() queryParams, @Body() activityDto:ActivityDTO, @Req() request: Request): Promise<ActivityResponseModel> {
        try {
            return await this.activityService.updateActivity(queryParams, activityDto, request);
        } catch (error) {
            return errorHandler(ActivityResponseModel, error);
        }
    }
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/updateActivityStatus')
    @ApiQuery({name:'apiVersion'})
    async updateActivityStatus(@Query() queryParams, @Body() activityStatusDTO: ActivityStatusDTO, @Req() request: Request): Promise<ActivityResponseModel> {
        try {
            return await this.activityService.updateActivityStatus(queryParams, activityStatusDTO, request);
        } catch (error) {
            return errorHandler(ActivityResponseModel, error);
        }
    }
}



